export const isQuotaExceededError = (err: unknown): boolean => {
  return (
    err instanceof DOMException &&
    // everything except Firefox
    // everything except Firefox
    (err.name === 'QuotaExceededError' ||
      // Firefox
      err.name === 'NS_ERROR_DOM_QUOTA_REACHED')
  );
};
